// Portfolio folder configuration.
export const PORTFOLIO_FOLDERS = [
  {
    id: 'case-studies',
    accent: '#175A96',
    tabColor: '#0F3E68',
    stampColor: '#08131F',
    rotation: 1.9,
    files: [
      { key: 'linkedinPresence', type: 'gallery', thumb: '/casestudies/linkedin-presence.jpg',
        pages: ['/casestudies/pages/linkedin-presence-p1.jpg', '/casestudies/pages/linkedin-presence-p2.jpg'] },
      { key: 'newsletterGrowth', type: 'gallery', thumb: '/casestudies/newsletter-growth.jpg',
        pages: ['/casestudies/pages/newsletter-growth-p1.jpg', '/casestudies/pages/newsletter-growth-p2.jpg'] },
    ],
  },
  {
    id: 'websites',
    accent: '#526779',
    tabColor: '#3A4F60',
    stampColor: '#08131F',
    rotation: 2.1,
    files: [
      { key: 'fellsor', type: 'site', src: '/websites/fellsorprojekt.jpg', href: 'https://fellsorprojekt.se/', tag: 'Created' },
      { key: 'roguewmn', type: 'site', src: '/websites/roguewmn.jpg', href: 'https://www.roguewmn.com/', tag: 'Created' },
      { key: 'vitalize', type: 'site', src: '/websites/vitalize.jpg', href: 'https://www.vitalize.vc/', tag: 'Redesigned' },
    ],
  },
  {
    id: 'freelance-ai',
    accent: '#0F3E68',
    tabColor: '#08131F',
    stampColor: '#08131F',
    rotation: -1.6,
    files: [
      { key: 'angleSauce', type: 'site', href: 'https://angle-sauce.netlify.app/' },
      { key: 'citationMagnet', type: 'site', href: 'https://citation-checklist.netlify.app/' },
      { key: 'bodegaToolshed', type: 'site', href: 'https://bodega-toolshed.netlify.app/' },
      { key: 'keywordWheel', type: 'site', href: 'https://keyword-wheel.netlify.app/' },
      { key: 'brandBriefBuilder', type: 'site', href: 'https://brand-brief-builder.netlify.app/' },
      { key: 'websiteLaunchChecklist', type: 'site', href: 'https://website-launch-checklist.netlify.app/' },
      { key: 'companyDecoder', type: 'site', href: 'https://company-decoder.netlify.app/' },
      { key: 'personalBrandingPlaybook', type: 'site', href: 'https://personal-branding-playbook.netlify.app/' },
      { key: 'vibeField', type: 'site', href: 'https://vibe-field.netlify.app/' },
      { key: 'findOverlap', type: 'site', href: 'https://find-overlap.netlify.app/' },
      { key: 'microCoursePlanner', type: 'site', href: 'https://microcourse-planner.netlify.app/' },
      { key: 'whichCameFirst', type: 'site', href: 'https://which-came-first.netlify.app/' },
      { key: 'sideQuest', type: 'site', href: 'https://the-side-quest.netlify.app/' },
      { key: 'howCameraSees', type: 'site', href: 'https://how-a-camera-sees.netlify.app/' },
      { key: 'ctaShowdown', type: 'site', href: 'https://cta-showdown.netlify.app/' },
      { key: 'landingHeroHelper', type: 'site', href: 'https://landing-hero-helper.netlify.app/' },
      { key: 'processPulseCheck', type: 'site', href: 'https://ops-auditor.netlify.app/' },
      { key: 'onboardingTrail', type: 'site', href: 'http://onboarding-trail.netlify.app/' },
      { key: 'projectProof', type: 'site', href: 'https://project-proof.netlify.app/' },
      { key: 'moodForecast', type: 'site', href: 'https://mood-forecast.netlify.app/' },
      { key: 'memoryRoom', type: 'site', href: 'https://memory-room.netlify.app/' },
      { key: 'lookAgain', type: 'site', href: 'https://look-again.netlify.app/' },
    ],
  },
  {
    id: 'graphics',
    accent: '#FFDE59',
    tabColor: '#D4B437',
    stampColor: '#8A7422',
    rotation: -2.2,
    files: [
      { key: 'workHard1', type: 'image', src: '/graphics/post-1.jpg' },
      { key: 'workHard2', type: 'image', src: '/graphics/post-2.jpg' },
      { key: 'gainEdge', type: 'image', src: '/graphics/post-3.jpg' },
      { key: 'newTalent', type: 'image', src: '/graphics/post-4.jpg' },
      { key: 'trainProfile', type: 'image', src: '/graphics/post-5.jpg' },
      { key: 'podcastPlaybook', type: 'image', src: '/graphics/podcast-playbook.jpg' },
      { key: 'podcastSeth', type: 'image', src: '/graphics/podcast-seth.jpg' },
      { key: 'podcastSecrets', type: 'image', src: '/graphics/podcast-secrets.jpg' },
      { key: 'conferenceBanner', type: 'image', src: '/graphics/conference-banner.png' },
      { key: 'xBanner', type: 'image', src: '/graphics/x-banner.jpg' },
    ],
  },
  {
    id: 'linkedin-carousels',
    accent: '#009FFD',
    tabColor: '#007ACC',
    stampColor: '#004F87',
    rotation: 1.5,
    files: [
      { key: 'threeMistakes', type: 'gallery', thumb: '/carousels/3-mistakes.jpg',
        pages: ['/carousels/pages/3-mistakes-p1.jpg','/carousels/pages/3-mistakes-p2.jpg','/carousels/pages/3-mistakes-p3.jpg','/carousels/pages/3-mistakes-p4.jpg','/carousels/pages/3-mistakes-p5.jpg','/carousels/pages/3-mistakes-p6.jpg'] },
      { key: 'nineMistakesEAs', type: 'gallery', thumb: '/carousels/9-mistakes-eas.jpg',
        pages: ['/carousels/pages/9-mistakes-eas-p1.jpg','/carousels/pages/9-mistakes-eas-p2.jpg','/carousels/pages/9-mistakes-eas-p3.jpg','/carousels/pages/9-mistakes-eas-p4.jpg','/carousels/pages/9-mistakes-eas-p5.jpg','/carousels/pages/9-mistakes-eas-p6.jpg','/carousels/pages/9-mistakes-eas-p7.jpg','/carousels/pages/9-mistakes-eas-p8.jpg','/carousels/pages/9-mistakes-eas-p9.jpg','/carousels/pages/9-mistakes-eas-p10.jpg','/carousels/pages/9-mistakes-eas-p11.jpg'] },
      { key: 'adaptabilitySnygg', type: 'gallery', thumb: '/carousels/adaptability-snygg.jpg',
        pages: ['/carousels/pages/adaptability-snygg-p1.jpg','/carousels/pages/adaptability-snygg-p2.jpg','/carousels/pages/adaptability-snygg-p3.jpg','/carousels/pages/adaptability-snygg-p4.jpg','/carousels/pages/adaptability-snygg-p5.jpg'] },
      { key: 'ea40Hours', type: 'gallery', thumb: '/carousels/ea-40-hours.jpg',
        pages: ['/carousels/pages/ea-40-hours-p1.jpg','/carousels/pages/ea-40-hours-p2.jpg','/carousels/pages/ea-40-hours-p3.jpg','/carousels/pages/ea-40-hours-p4.jpg','/carousels/pages/ea-40-hours-p5.jpg','/carousels/pages/ea-40-hours-p6.jpg','/carousels/pages/ea-40-hours-p7.jpg','/carousels/pages/ea-40-hours-p8.jpg'] },
      { key: 'scoutsVerified', type: 'gallery', thumb: '/carousels/scouts-verified.jpg',
        pages: ['/carousels/pages/scouts-verified-p1.jpg','/carousels/pages/scouts-verified-p2.jpg','/carousels/pages/scouts-verified-p3.jpg','/carousels/pages/scouts-verified-p4.jpg','/carousels/pages/scouts-verified-p5.jpg','/carousels/pages/scouts-verified-p6.jpg','/carousels/pages/scouts-verified-p7.jpg'] },
    ],
  },
];
